export const knmRequirementTemplatesGetBasicParams = {
  needRequirements: true,
  size: '2000',
};
